import { render, staticRenderFns } from "./FunctionEditor.vue?vue&type=template&id=21a016d1&scoped=true"
import script from "./FunctionEditor.vue?vue&type=script&lang=js"
export * from "./FunctionEditor.vue?vue&type=script&lang=js"
import style0 from "./FunctionEditor.vue?vue&type=style&index=0&id=21a016d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a016d1",
  null
  
)

export default component.exports